const BaubleTypes = {
  RED: 'red',
  BLUE: 'blue',
  YELLOW: 'yellow',
} as const;

export type BaubleType = (typeof BaubleTypes)[keyof typeof BaubleTypes];

export default BaubleTypes;
